<template>
  <v-menu
    origin="top right"
    :close-on-content-click="false"
    v-model="menu" id="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    :disabled="readonly || disabled"
    content-class="elevation-0"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        v-model="dateFormated" id="dateFormated"
        :label="label"
        append-icon="event"
        mask="##/##/####"
        :validate-on-blur="true"
        @blur="parseDate()"
        :readonly="readonly"
        :disabled="readonly || disabled"
        :clearable="clearable"
        :rules="reglas()"
        :hide-details="hideDetails"
      />
    </template>
    <v-date-picker 
      no-title 
      first-day-of-week="1" 
      locale="es-es" 
      :width="width"
      ref="picker"
      v-model="date" id="date"
      :max="max"
      :min="min"
      :disabled="readonly || disabled"
      @input="menu = false"
      :hide-details="hideDetails"
    />
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      type: String
    },
    width: {
      type: String
    },
    obligatorio: {
      default: false
    },
    nacimiento: {
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    anteriorAHoy: {
      type: Boolean,
      default: false
    },
    textDateFormat: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    valueDateFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    }
  },
  created () {
    this.updateFormatted(this.value)
  },
  data () {
    return {
      dateFormated: null,
      menu: false
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    reglas (/* v */) {
      if (!this.obligatorio || this.menu) {
        return []
      } else {
        return [!!this.value || 'La fecha es obligatoria']
      }
    },
    parseDate () {
      if (!this.dateFormated) {
        this.$emit('input', null)
        return
      }
      let valDate = moment(this.dateFormated, this.textDateFormat)
      if (valDate.isValid()) {
        if (this.menorQueMin(valDate) || this.mayorQueMax(valDate)) {
          this.dateFormated = null
          this.$emit('input', null)
          return
        }
        if (!moment(this.dateFormated, this.textDateFormat, true).isValid()) {
          this.dateFormated = valDate.format(this.textDateFormat)
        }
        this.$emit('input', moment(this.dateFormated, this.textDateFormat).format(this.valueDateFormat))
      } else {
        this.dateFormated = null
        this.$emit('input', null)
      }
    },
    updateFormatted (newVal) {
      this.dateFormated = newVal ? moment(newVal, this.valueDateFormat).format(this.textDateFormat) : null
    },
    mayorQueMax (date) {
      let maxDate = moment(this.max)
      if (!maxDate.isValid()) {
        return false
      }
      return date.isAfter(maxDate) && !date.isSame(maxDate)
    },
    menorQueMin (date) {
      let minDate = moment(this.min)
      if (!minDate.isValid()) {
        return false
      }
      return date.isBefore(minDate) && !date.isSame(minDate)
    }
  },
  watch: {
    value (newVal) {
      this.updateFormatted(newVal)
    },
    menu (val) {
      if (this.nacimiento) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    }
  }
}
</script>
